import { useState, useEffect } from "react";
import { Input } from "antd";
import { FaPlusCircle, FaTrash } from "react-icons/fa";
import { useSnackbar } from "../../../../context/SnackBarContext";
import LoaderButton from "../../../../component/LoaderButton";
import MultipleSelect from "../../../../component/MultipleSelect";
import fetcher from "../../../../helper/fetcher";

const titleOptions = [
  { name: "Cutting Master" },
  { name: "Handwork Issue" },
  { name: "Washing Issue" },
  { name: "Pressing Issue" },
  { name: "Packaging" },
  { name: "Shoot" },
  { name: "Other" },
];

const AddIndirectSales = ({ defaultData = [], onClose, setRefetch }) => {
  const [items, setItems] = useState([
    { itemName: "", rateValue: "" },
  ]);

  console.log("alskjdklas===>>", defaultData)
  const [miscItem, setMiscItem] = useState({ itemName: "", avgValue: "" });
  const [loading, setLoading] = useState(false);
  const { showSuccess, showError } = useSnackbar();

  const handleAddRow = () => {
    setItems([
      ...items,
      { itemName: "", rateValue: "" },
    ]);
  };


  useEffect(() => {
    if (defaultData?.steps) {
      const previous = defaultData.steps.map((row) => ({
        itemName: row.title,
        rateValue: Number(row.cost) || 0,
      }))
      setItems(previous)
    }

    if (defaultData?.miscellaneous) {
      setMiscItem({
        itemName:  defaultData?.miscellaneous?.title,
        avgValue: Number(defaultData?.miscellaneous?.cost) || 0
      })
    }
  }, [])

  const handleDeleteRow = (index) => {
    const updatedItems = items.filter((_, i) => i !== index);
    setItems(updatedItems);
  };

  const handleChange = (index, field, value) => {
    const updatedItems = [...items];
    updatedItems[index][field] = value;
    setItems(updatedItems);
  };

  const handleSubmit = () => {
    setLoading(true);

    for (let i = 0; i < items.length; i++) {
      if (!items[i].itemName.trim()) {
        showError(`Title is required for Item-${i + 1}`);
        setLoading(false);
        return;
      }
    }

    // Map frontend items → backend steps
    const steps = items.map((row) => ({
      title: row.itemName,
      cost: Number(row.rateValue) || 0,
    }));

    // Map misc → backend miscellaneous
    const miscellaneous = {
      title: miscItem.itemName || "",
      cost: Number(miscItem.avgValue) || 0,
    };

    // Calculate total amount
    const totalAmount =
      steps.reduce((acc, row) => acc + (row.cost || 0), 0) +
      (miscellaneous.cost || 0);

    // Prepare final payload for backend schema
    const payload = {
      totalAmount,
      steps,
      miscellaneous,
    };

    fetcher
      .patch(`/inventory/indirect_sale/update_indirect_sale/${defaultData?._id}`, payload)
      .then((res) => {
        showSuccess("Indirect sales added successfully!");
      })
      .catch((err) => {
        showError("Failed to add indirect sales");
      })
      .finally(() => {
        setLoading(false);
        onClose();
        setRefetch((prev) => prev + 1);
      });
  };

  return (
    <div className="space-y-4 p-4">
      {items.map((item, index) => (
        <div
          key={index}
          className="p-2 bg-gray-100 px-3 py-5 rounded-[10px] border border-gray-300 mb-4"
        >
          <div className="flex flex-row justify-between items-center mb-4">
            <p className="font-bold text-gray-800 text-[16px]">#{index + 1}</p>
            {index !== 0 && (
              <button
                onClick={() => handleDeleteRow(index)}
                className="text-red-500 hover:text-red-700"
              >
                <FaTrash size={20} />
              </button>
            )}
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-sm text-gray-600 mb-1">
                Title *
              </label>
              <MultipleSelect
                label="Title"
                name="itemName"
                options={titleOptions}
                value={item.itemName}
                onChange={(e) => handleChange(index, "itemName", e.target.value)}
                placeholder="Select Title"
              />
            </div>
            <div>
              <label className="block text-sm text-gray-600 mb-1">Cost</label>
              <Input
                value={item.rateValue}
                onChange={(e) =>
                  handleChange(index, "rateValue", e.target.value)
                }
                placeholder="Rate Value"
                className="w-full rounded"
                type="number"
              />
            </div>
          </div>
        </div>
      ))}

      <button
        onClick={handleAddRow}
        className="flex items-center text-red-500 hover:text-red-700"
      >
        <FaPlusCircle size={20} className="mr-2" /> Add Row
      </button>

      <hr />

      {/* Miscellaneous Card */}
      <div className="p-2 bg-gray-100 px-3 py-5 rounded-[10px] border border-gray-300 mb-4">
        <p className="font-bold text-gray-800 text-[16px] mb-4">
          Miscellaneous
        </p>

        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className="block text-sm text-gray-600 mb-1">Title</label>
            <Input
              value={miscItem.itemName}
              onChange={(e) =>
                setMiscItem({ ...miscItem, itemName: e.target.value })
              }
              placeholder="Miscellaneous Title"
              className="w-full rounded"
            />
          </div>
          <div>
            <label className="block text-sm text-gray-600 mb-1">Cost</label>
            <Input
              value={miscItem.avgValue}
              onChange={(e) =>
                setMiscItem({ ...miscItem, avgValue: e.target.value })
              }
              placeholder="Miscellaneous Cost"
              className="w-full rounded"
              type="number"
            />
          </div>
        </div>
      </div>

      <div className="flex justify-end items-end mr-4">
        <label className="block text-sm text-black mb-1 font-bold">
          Total Cost = ₹
          {(
            items.reduce((acc, row) => {
              const value = parseFloat(row.rateValue);
              return acc + (isNaN(value) ? 0 : value);
            }, 0) + (parseFloat(miscItem.avgValue) || 0)
          ).toFixed(2)}
        </label>
      </div>

      <div className="flex justify-between items-center my-5">
        <LoaderButton
          label={"Save"}
          isLoading={loading}
          handleClick={handleSubmit}
        />
      </div>
    </div>
  );
};

export default AddIndirectSales;
